{
  "fr": {
    "help": {
      "headings": {
        "additionalModelsNote": "En outre, d'autres modèles avec des caractéristiques différentes sont disponibles.",
        "contact": "Votre question n'était pas là ?",
        "contactSubtitle": "Contactez-nous - nous serons ravis de vous aider.",
        "currentTextModels": "Modèles de texte actuels",
        "free": "Ces limites s'appliquent à vous avec votre licence actuelle :",
        "imageModels": "Modèles d'image",
        "imageModelsIntro": "Ces modèles peuvent générer des images à partir de descriptions textuelles.",
        "ttsModels": "Modèles de texte-à-parole",
        "ttsModelsIntro": "Ces modèles peuvent convertir du texte en une voix naturelle.",
        "transcriptionModels": "Modèles de transcription",
        "transcriptionModelsIntro": "Ces modèles peuvent transcrire des enregistrements audio en texte.",
        "languageModelIntro": "Fobizz propose divers modèles d'IA. Les modèles les plus récents et performants sont toujours intégrés. Cela nécessite que les modèles soient compatibles avec nos exigences de protection des données et que suffisamment de capacités soient disponibles pour les besoins de fobizz. Étant donné que les nouveaux modèles sont publiés par les fournisseurs à des intervalles irréguliers, il n'y a pas de calendrier fixe - nous évaluons chaque nouveau modèle rapidement et l'intégrons dès que les conditions mentionnées sont remplies.",
        "languageModelVideoIntro": "Quel modèle convient à ma tâche ?",
        "languageModelVideoDescription": "Dans la vidéo suivante, nous expliquons les différences entre les modèles ouverts et fermés, les petits modèles rapides et les puissants modèles de raisonnement — et quand chaque modèle est le meilleur choix.",
        "languageModels": "Modèles de texte",
        "largeModel": "Un grand modèle",
        "largeModelDescription": "fournit des réponses plus détaillées. Ce modèle est particulièrement adapté aux requêtes nécessitant plus de détails et le traitement de contextes plus larges.",
        "limits": "Limites",
        "modelCards": "Aperçu des modèles d'IA",
        "modelTypesIntro": "Fobizz privilégie les modèles ouverts et recommande toujours deux alternatives dans cet ordre dans le Chat IA :",
        "openSourceLanguageModels": "Modèles Open Source",
        "plugins": "Plugins",
        "proprietaryLanguageModels": "Modèles propriétaires",
        "reasoningModel": "Un modèle de raisonnement",
        "reasoningModelDescription": "possède des capacités analytiques particulières. Ce modèle est particulièrement adapté aux tâches complexes nécessitant des processus de pensée logique et des déductions à plusieurs étapes.",
        "references": "Sources",
        "searchResults": "Résultats de recherche",
        "smallModel": "Un petit modèle",
        "smallModelDescription": "est particulièrement rapide et efficace. Ce modèle est particulièrement adapté aux dialogues rapides, aux tâches de contenu et aux réponses simples.",
        "subtitle": "Conseils et réponses de l'équipe fobizz",
        "welcome": "Bienvenue dans l'aide fobizz"
      },
      "chatbot": {
        "title": "Demandez au Chatbot du centre d'aide",
        "description": "Posez votre question à notre Chatbot, qui peut vous renseigner sur tous les sujets concernant fobizz et les outils fobizz.",
        "url": "https://app.fobizz.com/ai/chats/public_assistants/d6272da2-35ae-4b68-8594-14a0da9d4029?token=ef7ab9adca3e758f0aa7d6808605c6a9"
      },
      "labels": {
        "articles": "0 article | 1 article | {count} articles",
        "contextWindow": "Fenêtre de contexte",
        "input": "Entrée",
        "knowledgeCutoff": "Seuil de connaissance",
        "lastUpdated": "Dernière mise à jour le",
        "maxTokens": "Jetons maximum",
        "modelCardUrl": "Documentation de référence",
        "opensInNewTab": "ouvre dans un nouvel onglet",
        "reasoning": "Raisonnement",
        "recommended": "Recommandé",
        "searchResults": "Questions & Réponses"
      },
      "links": {
        "allCategories": "Toutes les catégories",
        "backToHelp": "Retour à l'aide"
      },
      "paragraphs": {
        "contactEmail": "Écrivez-nous un e-mail.",
        "contactPhone": "Appelez-nous : Lun à Ven 8h-16h",
        "contactSales": "Prendre rendez-vous pour une consultation",
        "contactSchoolLicense": "Pour des questions sur les licences scolaires",
        "disclaimer": "Tous les modèles de langage répertoriés ici sont hébergés dans des centres de données <strong>européens</strong> ou <strong>allemands</strong> - à l'exception des modèles de <strong>OpenAI</strong> et <strong>Anthropic</strong>.",
        "intro": "Avec un compte gratuit, vous pouvez tester fobizz sans engagement, utiliser un extrait du catalogue de formations et obtenir une limite mensuelle pour les outils.",
        "outro": "Les contenus créés peuvent être utilisés même après la fin d'un abonnement ou d'une licence scolaire. Vous trouverez des informations précises sur les conditions des différentes offres fobizz dans la <a href=\"https://plattform.fobizz.com/preistabelle\" target=\"_blank\">table des prix</a>.",
        "plugins": "Tous les modèles compatibles avec les plugins ont automatiquement accès aux intégrations suivantes. Les plugins suivants sont actuellement disponibles et peuvent améliorer considérablement les capacités des assistants IA.",
        "recommendedForHelp": "Les suggestions sont basées sur vos <a href=\"{profileSettingsUrl}\" target=\"_blank\">paramètres de profil</a>.<br>Modifiez-les si nécessaire."
      },
      "search": {
        "noResults": "Malheureusement, il n'y a pas de correspondance exacte. Veuillez essayer un autre mot-clé ou une autre orthographe."
      },
      "table": {
        "contextWindow": "Fenêtre de contexte",
        "featureNames": "Fonctions",
        "maxTokens": "Jetons maximum",
        "model": "Modèle",
        "openSource": "Ouvert",
        "provider": "Fournisseur",
        "reasoning": "Raisonnement",
        "supportsFunctions": "Plugins",
        "supportsVision": "Traitement d'image",
        "supportsImageGeneration": "Génération",
        "sizes": "Tailles"
      }
    }
  }
}
